"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.decrypt = exports.encrypt = exports.initConfig = void 0;
//@ts-ignore
var jsencrypt_1 = __importDefault(require("jsencrypt"));
//@ts-ignore
var enc_base64_1 = __importDefault(require("crypto-js/enc-base64"));
//@ts-ignore
var enc_utf8_1 = __importDefault(require("crypto-js/enc-utf8"));
//@ts-ignore
var aes_1 = __importDefault(require("crypto-js/aes"));
//@ts-ignore
var pad_pkcs7_1 = __importDefault(require("crypto-js/pad-pkcs7"));
var _charset = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z'
];
var _config = {};
var refreshPromise = null;
var aes = {
    key: '',
    iv: '',
    'Encryption-Parameters': ''
};
function randomString(chars, n) {
    var res = '';
    for (var i = 0; i < n; i++) {
        //@ts-ignore
        var id = Math.ceil(Math.random() * (chars.length - 1));
        res += chars[id];
    }
    return res;
}
function decrypt(content) {
    content = content instanceof Object ? JSON.stringify(content) : content;
    if (!_config.isEncryption || !isValid()) {
        return content;
    }
    var decrypt_res = aes_1.default.decrypt(content, enc_utf8_1.default.parse(aes.key), {
        iv: enc_utf8_1.default.parse(aes.iv),
        // mode: CryptoJS.mode.CBC,
        padding: pad_pkcs7_1.default
    });
    return decrypt_res.toString(enc_utf8_1.default);
}
exports.decrypt = decrypt;
function encrypt(params) {
    return __awaiter(this, void 0, void 0, function () {
        var content, isEncryptHeaders, result;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    content = params.content, isEncryptHeaders = params.isEncryptHeaders;
                    return [4 /*yield*/, initConfig()];
                case 1:
                    _b.sent();
                    if (_config.isEncryption) {
                        result = {
                            content: setDataEncrypt(content),
                        };
                        if (isEncryptHeaders) {
                            result = __assign(__assign({}, result), (_a = {}, _a['Encryption-Parameters'] = aes['Encryption-Parameters'], _a['Encryption-Algorithm'] = _config.algorithm, _a['Content-Type'] = 'text/plain', _a));
                        }
                        return [2 /*return*/, result];
                    }
                    return [2 /*return*/, params];
            }
        });
    });
}
exports.encrypt = encrypt;
function initConfig(config) {
    return __awaiter(this, void 0, void 0, function () {
        var params, commonNetwork, result, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (isValid() || refreshPromise) {
                        return [2 /*return*/, refreshPromise];
                    }
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 6, 7, 8]);
                    if (!!config) return [3 /*break*/, 4];
                    params = {
                        method: 'GET',
                        url: '/ai_entry/v3/encrypted/info',
                    };
                    return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('../plugins/network/common-network')); })];
                case 2:
                    commonNetwork = (_a.sent()).default;
                    refreshPromise = commonNetwork.request(__assign(__assign({}, params), { method: 'GET' // or 'POST' depending on the desired HTTP method
                     }));
                    return [4 /*yield*/, refreshPromise];
                case 3:
                    result = _a.sent();
                    _config = __assign({}, result.data);
                    return [3 /*break*/, 5];
                case 4:
                    _config = __assign({}, config);
                    _a.label = 5;
                case 5:
                    if (_config.isEncryption) {
                        setHeaderParams();
                    }
                    return [3 /*break*/, 8];
                case 6:
                    e_1 = _a.sent();
                    console.error(e_1);
                    return [3 /*break*/, 8];
                case 7:
                    refreshPromise = null;
                    return [7 /*endfinally*/];
                case 8: return [2 /*return*/];
            }
        });
    });
}
exports.initConfig = initConfig;
function setHeaderParams() {
    var _a;
    aes.key = randomString(_charset, 32);
    aes.iv = randomString(_charset, 16);
    var encryption_parameters = {
        private_key: btoa(aes.key),
        iv: aes.iv
    };
    encryption_parameters = JSON.stringify(encryption_parameters);
    var encrypt = new jsencrypt_1.default();
    var publicKey = enc_base64_1.default.parse((_a = _config.publicKey) !== null && _a !== void 0 ? _a : '').toString(enc_utf8_1.default);
    encrypt.setPublicKey(publicKey);
    encryption_parameters = encrypt.encrypt(encryption_parameters);
    aes['Encryption-Parameters'] = encryption_parameters;
}
function setDataEncrypt(data) {
    if (data) {
        data = data instanceof Object ? JSON.stringify(data) : data;
        var key = enc_utf8_1.default.parse(aes.key);
        var iv = enc_utf8_1.default.parse(aes.iv);
        var encrypt_content = aes_1.default.encrypt(data, key, {
            iv: iv,
            // 默认使用CBC模式
            // mode: CryptoJS.mode.CBC,
            padding: pad_pkcs7_1.default
        });
        data = enc_base64_1.default.stringify(encrypt_content.ciphertext);
    }
    return data;
}
function isValid() {
    return _config.expires;
}
